import { useEffect } from 'react';
import * as Sentry from '@sentry/react';

import { useUser } from '@clerk/react';

/**
 * Identifies the current Clerk user in Sentry so errors and replays are
 * tagged with user id, email, and username. Clears the identity on sign-out.
 *
 * Renders nothing - mount once inside the authenticated tree.
 */
export function SentryUserSync() {
  const { isLoaded, isSignedIn, user } = useUser();

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn && user) {
      Sentry.setUser({
        id: user.id,
        email: user.primaryEmailAddress?.emailAddress,
        username: user.username ?? user.fullName ?? undefined,
      });
    } else {
      Sentry.setUser(null);
    }
  }, [isLoaded, isSignedIn, user]);

  return null;
}
